import { useQuery } from '@tanstack/react-query';
import * as dashboardApi from '../api/dashboard';
import type { DashboardData } from '../api/dashboard';

export function useDashboardStats() {
  return useQuery<DashboardData>({
    queryKey: ['dashboard', 'stats'],
    queryFn: dashboardApi.fetchDashboardStats,
    staleTime: 60_000, // 1 minute
    refetchInterval: 5 * 60_000, // Auto-refresh every 5 minutes
  });
}
